import React from 'react'
import Link from 'gatsby-link'
import { css } from 'emotion'
import styled from 'react-emotion'

import Section from '../components/section/Section'

import facebook from '../assets/facebook-icon.svg'
import instagram from '../assets/instagram-icon.svg'
import linkedin from '../assets/linkedin-icon.svg'
import twitter from '../assets/twitter-icon.svg'
import HubspotForm from './forms/HubspotForm'

const FooterClass = css`
  clear: both;
  background-color: #00b386;
  display: flex;
  flex-direction: column-reverse;
  padding-bottom: 10rem;
  padding-top: 3rem;

  @media (min-width: 767px) {
    flex-direction: row;   
  }
`

const NavContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
`

const Nav = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  position:relative;
  z-index: 1;
  padding-top: 1rem;

  @media (min-width: 767px) {
    border-top: none;
    padding-top: 0;    
  }
`

const NavList = styled.ul`
  list-style: none;
  padding: 0.5rem;
  font-size: 1.2rem;
  line-height: 1.5rem;

  &:last-child {
    border: none;
  }

  @media (min-width: 767px) {
    padding: 1rem 2rem;
  }
`

const NavListItem = styled.li(props => `
  color: white;
  margin-bottom: 1rem;
  font-weight: ${props.bold ? 'bold' : '300'};

  a {
    color: white
  }
`)

const Icon = styled.img`
  max-width: 3rem;
  max-height: 3rem;
  margin-right: 1rem;
  color: white;
`

const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  z-index: 10;

  @media (min-width: 767px) {
    flex-direction: row;
  }
`

const EmailSubscribeContainer = styled.div`
  flex: 2;
  padding: 3rem;
  text-align: center;
  color: white;
  background-color: rgb(252 199 27 / 1);
`

const EmailCTAHeader = styled.h3`
  font-size: 3rem;
`

class Footer extends React.Component {
  shouldComponentUpdate() { return false; }
  render() {
    return (
      <footer>
        <Section className={FooterClass} shading>
          <Container>
            <NavContainer>
              <Nav>
                <NavList>
                  <NavListItem>
                    <Link to={'/#partners'}>Partners</Link>
                  </NavListItem>
                  <NavListItem>
                    <Link to={'/#how-it-works'}>How It Works</Link>
                  </NavListItem>
                  <NavListItem>
                    <Link to={'/#features'}>Features</Link>
                  </NavListItem>
                  <NavListItem>
                    <Link to={'/testimonials'}>Testimonials</Link>
                  </NavListItem>
                  <NavListItem>
                    <a href={'https://app.trywhistle.com/login'}>Login</a>
                  </NavListItem>
                  {/*<NavListItem>Blog</NavListItem>*/}
                </NavList>
                <NavList>
                  <NavListItem>
                    <Link to={'/news'}>News</Link>
                  </NavListItem>
                  <NavListItem>
                    <Link to={'/tos'}>Terms of Use</Link>
                  </NavListItem>
                  <NavListItem>
                    <Link to={'/privacy'}>Privacy Policy</Link>
                  </NavListItem>
                </NavList>            
              </Nav>
              <Nav>
                <NavList>
                  <NavListItem bold>Contact Us</NavListItem>
                  <NavListItem>sales@trywhistle.com</NavListItem>
                  <NavListItem>Whistle Messaging, Inc. <br/>Los Angeles, CA 91361</NavListItem>
                </NavList>
              </Nav>
              <Nav>
                <NavList>
                  <NavListItem bold>Follow Us</NavListItem>
                  <NavListItem>
                    <a href={'https://www.linkedin.com/company/whistle-inc-/'} rel="noopener noreferrer" target="_blank">
                      <Icon src={linkedin} />
                    </a>
                    <a href={'https://www.instagram.com/whistlemessaging/'} rel="noopener noreferrer" target="_blank">
                      <Icon src={instagram} />
                    </a>
                    <a href={'https://www.facebook.com/trywhistle'} rel="noopener noreferrer" target="_blank">
                      <Icon src={facebook} />
                    </a>
                    <a href={'https://twitter.com/trywhistle'} rel="noopener noreferrer" target="_blank">
                      <Icon src={twitter} />
                    </a>
                  </NavListItem>
                </NavList>
              </Nav>
            </NavContainer>
            <EmailSubscribeContainer>
              <EmailCTAHeader>Hi there!</EmailCTAHeader>
              <h4>GET UPDATES, OFFERS, INSIDER INFORMATION AND MORE. </h4>
              <br/>
              <p>Sign up below to get Whistling.</p>
              <HubspotForm
                id="email-subscribers"
                formId="062b7602-8729-4618-bc12-2ceeb2842e10"
              />
              <p>We will protect your personal information. See our <Link to={'/privacy'}>Privacy Policy</Link> for more details. </p>
            </EmailSubscribeContainer>
          </Container>
        </Section>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js